export default __webpack_public_path__ + "images/drag-image-icon.51b247d147250df1ca93cbbe70a77bf3.svg";